import { AuditEntitySlug } from 'lib/enum/audit.enum';
import { AuditEntry } from 'lib/types/audit-type';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchAuditEntries = async (entitySlug: AuditEntitySlug, entityId: string): Promise<AuditEntry[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<AuditEntry[]>(`audit/${entitySlug}/${entityId}`);

export const CancelableAuditEntryGateway = {
    cancelableFetchAuditEntries,
};
